import { Github } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { TokenBuddyLogo } from "./TokenBuddyLogo";

export function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-[var(--color-line)] bg-[var(--color-page-soft)]">
      <div className="page-container grid gap-6 py-7 text-[12px] text-[var(--color-muted)] md:grid-cols-[minmax(0,1fr)_auto] md:items-start md:py-8">
        <div className="max-w-[560px]">
          <TokenBuddyLogo />
          <p className="mt-3 text-[13px] leading-6 text-[var(--color-text)]">
            {t("footer.tagline")}
          </p>
          <p className="mt-4">
            <Trans i18nKey="footer.copyright" values={{ year }} components={{ span: <span /> }} />
          </p>
        </div>

        <div className="grid gap-3 sm:min-w-[300px] sm:grid-cols-2">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--color-ink)]">
              {t("footer.product")}
            </p>
            <nav className="mt-2 grid gap-1" aria-label={t("footer.product")}>
              <a
                href="/#install"
                className="inline-flex min-h-9 items-center rounded-[var(--radius-sm)] text-[12.5px] font-bold transition-colors hover:text-[var(--color-ink)]"
              >
                {t("footer.install")}
              </a>
              <a
                href="/docs"
                className="inline-flex min-h-9 items-center rounded-[var(--radius-sm)] text-[12.5px] font-bold transition-colors hover:text-[var(--color-ink)]"
              >
                {t("footer.docs")}
              </a>
            </nav>
          </div>

          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--color-ink)]">
              {t("footer.github")}
            </p>
            <div className="mt-2 grid gap-1">
              <a
                href="https://github.com/zhouchangui/tokenbuddy-node"
                className="inline-flex min-h-9 items-center gap-1.5 rounded-[var(--radius-sm)] text-[12.5px] font-bold transition-colors hover:text-[var(--color-ink)]"
              >
                <Github className="h-3.5 w-3.5" aria-hidden="true" />
                {t("footer.github")}
              </a>
              <span className="inline-flex min-h-9 items-center text-[12.5px]">
                {t("footer.license")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
